import { useGetBillingSubscriptionIdByPartnerListingIdQuery, useSyncShopifyBillingSubscriptionMutation } from '../../../../../../../redux/slices/billingSlice'

const useBilling = (partnerId, partnerListingId, shopifyUrl) => {
  const {
    data: billingSubscription,
    isLoading: billingSubscriptionIsLoading,
    error: billingSubscriptionError,
  } = useGetBillingSubscriptionIdByPartnerListingIdQuery(partnerListingId)

  const [syncBillingSubscriptionForShopifyListing] = useSyncShopifyBillingSubscriptionMutation()
  const syncShopifyBillingSubscription = async (billingSubscriptionId) => {
    try {
      const result = await syncBillingSubscriptionForShopifyListing({
        billingSubscriptionId,
        partnerId,
        partnerListingId,
        shopifyUrl,
      }).unwrap()
      return result
    } catch (err) {
      console.error(err)
      throw err
    }
  }

  return {
    billingSubscription,
    billingSubscriptionIsLoading,
    billingSubscriptionError,
    syncShopifyBillingSubscription,
  }
}

export default useBilling
